import React from 'react'
import Skeleton from 'react-loading-skeleton';

const HistoryShimmer = ({ count = 2 }) => {
  return (
    <>
      {Array(count).fill(0).map((_, ind) => (
        <div key={ind} className="item" >
          <div className="content-left">
            <Skeleton circle height={40} width={40} />
            <p className='mx-3'>
              <b><Skeleton width={100} /></b>
              <span><Skeleton width={150} /></span>
            </p>
          </div>
          <p>
            <strong><Skeleton width={50} /></strong>
            <span><Skeleton width={110} /></span>
          </p>
        </div>
      ))}
    </>

  );
}

export default HistoryShimmer